import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CurvaAbcVendaFilter, CurvaAbcVendaFilterService } from '../../filter';
import { CurvaAbcVendaPerspectiva } from '../../perspectiva';

@Injectable({
    providedIn: 'root'
})
export class CurvaAbcVendaReportHttpService {
    resource = 'curvaabcvenda';
    private pathApi: string;


    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private curvaAbcVendaFilterService: CurvaAbcVendaFilterService) {
        this.pathApi = `${configServerService.getPathApiPrint()}/${this.resource}`;
    }

    /** Realiza a impressão da consulta da Curva ABC de Vendas */
    print(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string, nomeImpressao: string = ''): Observable<Blob> {
        let params = this.curvaAbcVendaFilterService.createHttpParams(perspectiva, filter, orderBy, orderByDir);
        params = params.append('nomeImpressao', nomeImpressao);
        return this.customHttp.post<Blob>(this.pathApi, null, {params, responseType: 'blob'});
    }
}
